<template>
	<div class="asin-list-monitoring2-main-div" >

		<div class="search-bar-div">
			<el-row>
				<el-col :span="16">
<!--					<el-button size="small" type="primary" disabled @click="singleDelete(tableChecked)">批量删除</el-button>-->
					<el-select v-model="search.sort" @change="searchFun(null)" placeholder="请选择" size="small" style="margin-left: 10px">
						<el-option :label="'默认排序'" :value="null"></el-option>
						<el-option :label="'自然排名正序'" :value="1"></el-option>
						<el-option :label="'自然排名倒序'" :value="2"></el-option>
						<el-option :label="'广告排名正序'" :value="4"></el-option>
						<el-option :label="'广告排名倒序'" :value="5"></el-option>
						<el-option :label="'创建时间正序'" :value="3"></el-option>
					</el-select>
				</el-col>
				<el-col :span="8" style="text-align: right">
					<el-button @click="searchFun(null)" size="small">刷新</el-button>
				</el-col>
			</el-row>
		</div>
		<!--表格-->
		<div class="table-div" v-loading="loading">
			<el-table class="el-table-20230223" :data="searchData.list"
				:header-cell-style="{ 'color' : '#606266' }"
				@selection-change="(val) => tableChecked = val.map(i => i.id)"
				:key="refreshTableDom" ref="asinTable" height="100%" >
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="商品信息" header-align="center" min-width="500">
					<template slot-scope="scope">
						{{ void(asinInfo=asinInfoList.find(i => i.asin === scope.row.asin) || {}) }}
						<div class="item-asin-info-div" v-loading="loadAsinLock">
							<div class="div-border-1" style="padding: 5px; display: inline-block;box-sizing: border-box">
								<el-image :src="asinInfo.imgs ? imgSizeSet(asinInfo.imgs[0]) : ''" fit="contain"
									style="height: 70px;width:70px"></el-image>
							</div>

							<div style="flex: 1;overflow: hidden;margin-left: 10px" >
								<span v-if="asinInfo.title" class="overflow-two-line" style="font-size: 15px">
									{{ asinInfo.title }}
								</span>
								<span v-else class="no-data-font"> -- </span>
								<!--asin详细数据-->
								<div class="asin-info">
									<asin-badge-sub :asinInfo="scope.row"></asin-badge-sub>
									<span>
										{{ scope.row.asin }}
										<copy-sub :value="scope.row.asin"></copy-sub>
										<a target="_blank" style="margin-left:5px;"
											:href="'https://www.' + getCountryObjByCity('US').department + '/dp/' + scope.row.asin"><i
											class="fa fa-plane" aria-hidden="true"></i></a>

									</span>

									<span v-if="asinInfo.brand">
										<span class="key">品牌: </span>
										<span class="value">{{ asinInfo.brand }}</span>
									</span>
									<span v-if="asinInfo.seller">
										<span class="key">卖家: </span>
										<span class="value">{{ asinInfo.seller }}</span>
										<span v-if="asinInfo.distributionMode" class="value">
											({{ asinInfo.distributionMode }})
										</span>
									</span>

									<span class="emphasis-hint" v-if="asinInfo.price">
										<span>{{ asinInfo.price }}</span>
									</span>

									<span>
										<span class="value">
											<el-rate v-model="asinInfo.score"
												disabled show-score text-color="#ff9900"
												class="el-rate-20230221" score-template="{value}"></el-rate>
											<span style="color: #ff9900;"> ({{ asinInfo.commentNum || 0 }})</span>
										</span>
									</span>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="BSR" align="center" width="80">
					<template slot-scope="scope">
						<el-popover popper-class="ranking-popover-div-202204291145"
							v-if="scope.row.ranking && scope.row.ranking.length > 0"
							placement="right" trigger="hover">
							<p :key="index" v-for="(item,index) in JSON.parse(scope.row.ranking)">
								{{ item.prod_section }} :
								<span style="font-weight: bolder;"> {{ item.rank }} </span>
							</p>
							<font slot="reference" color="#000000"
								style="border-bottom: 1px dotted #000000;cursor: pointer">
								{{ JSON.parse(scope.row.ranking)[0].rank }}
							</font>
						</el-popover>
						<span v-else class="no-data-font">
							{{ ' -- ' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="最新排名" prop="absolutePosition" align="left" header-align="center"
					width="120">
					<template slot-scope="scope">
						<div style="line-height:30px;">
							<div>自然排名：
								<span v-if="scope.row.absolutePosition">{{ scope.row.absolutePosition }}</span>
								<font color="#bebebe" v-else> — </font>
							</div>
							<div>广告排名：
								<span v-if="scope.row.adAbsolutePosition">{{ scope.row.adAbsolutePosition }}</span>
								<font color="#bebebe" v-else> — </font>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="排名趋势" align="center" width="230">
					<template slot-scope="scope">
						<div class="div-border-1">
							<chart-sub :option="scope.row.chartData" :data_height="80"></chart-sub>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="上架日期" align="center" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.uploadTime">
							{{ $fomatTime(scope.row.uploadTime) }}
						</span>
						<span v-else class="no-data-font"> -- </span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="140">
					<template slot-scope="scope">
						<el-button type="text" @click="openHistoryDialog(scope.row.id)">历史</el-button>&nbsp;
						<refresh-sub :asin="scope.row.asin">
							<el-button type="text">更新</el-button>
						</refresh-sub>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--分页-->
		<div class="page-div">
			<page-sub :background="true" layout="sizes,prev, pager, next"
				:page-sizes="[5,10,20, 30, 50]"
				@current-change="pageChange" @size-change="handleSizeChange"
				:total="searchData.total" :page-size="search.pageSize"
				:current-page="search.page"/>
		</div>
		<!--asin历史排名-->
		<el-dialog v-if="history.visible" :visible.sync="history.visible" width="1000px">
			<asin-rank-trends-sub :asin-task-id="history.asinTaskId"></asin-rank-trends-sub>
		</el-dialog>
	</div>
</template>

<script>
import {
	api_asin_batchAsinInfoQuery_public
} from "@/components/api/asinBasiceInfo";
import {
	api_asinInfoList_monitoring2, api_asinRankTrends_monitoring2, api_addAsin_monitoring2, api_asinDataPage_monitoring2
} from "@/components/api/keywordsMonitoring2";
import { imgSizeSet } from "@/components/common/utils/imgUtils";
import ASIN_BADGE_SUB from "@/components/template/view/keyword/monitoring/asinInfo/sub/badgeSub";
import COPY_SUB from "@/components/template/otherSub/copySub";
import REFRESH_ASIN_SUB from "@/components/template/view/sub/asin/refreshAsinData";
import { formatMonitoringPositionDataMini } from "@/components/config/chart/asinKeywordMini";
import Chart from "@/components/template/otherSub/hightChartSub";
import { getCountryByValue, getCountryObjByCity, getSymbolByCurrency } from "@/components/config/countryCodeConfig";
import PAGE_SUB from "@/components/template/otherSub/pageSub";
import ASIN_RANK_TRENDS_SUB from "@/components/template/view/keyword/monitoring2/sub/asinRankTrendsSub";

export default {
	name: "asinListMonitoring2",
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg'],
	data() {
		return {
			loading: false,
			search: {
				page: 1,
				pageSize: 10,
				sort: null,
			},
			searchData: {},
			asinInfoList : [],
			loadAsinLock : false,
			tableChecked : [],
			refreshTableDom: '',
			delAsinIds: [],
			history : {
				visible : false,
				asinTaskId : null
			},
		}
	},
	props: {
		monitorInfo: {
			required: true
		}
	},
	components : {
		'asin-badge-sub': ASIN_BADGE_SUB,
		'copy-sub' : COPY_SUB,
		'chart-sub': Chart,
		'page-sub': PAGE_SUB,
		'refresh-sub' : REFRESH_ASIN_SUB,
		'asin-rank-trends-sub' : ASIN_RANK_TRENDS_SUB
	},
	created() {
		this.$options.methods.searchFun(this)
	},
	methods: {
		searchFun : function(this_) {
			this_ = this_ || this
			this_.$data.search.page = 1
			this_.$options.methods.loadData(this_)
		},
		openHistoryDialog : function(asinTaskId) {
			this.$data.history.visible = true
			this.$data.history.asinTaskId = asinTaskId
		},
		pageChange: function(val) {
			this.$data.search.page = val
			this.$options.methods.loadData(this)
		},
		handleSizeChange: function(val) {
			this.$data.search.page = 1
			this.$data.search.pageSize = val
			this.$options.methods.loadData(this)
		},
		loadData: function(this_) {
			this_ = this_ || this
			if (this_.$data.loading) {
				return
			}
			//准备参数
			let params = this_.$data.search
			params.keywordsId = this_.monitorInfo.id
			//开启遮罩
			this_.$data.loading = true
			api_asinInfoList_monitoring2(params).then(res => {
				res.data.list = res.data.list.map(i => {
					i.chartData = formatMonitoringPositionDataMini(i.history)
					return i
				})
				this_.$data.searchData = res.data
				this_.$options.methods.loadAsinInfo(this_)
				//关闭遮罩
				this_.$data.loading = false
			}).catch(err => {
				console.error(err)
				//关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败'), 4)
			})
		},
		loadAsinInfo : function(this_) {
			this_ = this_ || this
			let asins = this_.$data.searchData.list.map(i => i.asin)
			if(asins.size <= 0 || this_.$data.loadAsinLock){
				return
			}
			// 上锁
			this_.$data.loadAsinLock = true
			api_asin_batchAsinInfoQuery_public([...asins]).then(res => {
				this_.$data.asinInfoList = res.data || []
				// 解锁
				this_.$data.loadAsinLock = false
			}).catch(err => {
				// 解锁
				this_.$data.loadAsinLock = false
				console.error(err)
			})
		},
		imgSizeSet: function(url, size = 80) {
			return imgSizeSet(url, size)
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
	},
	watch:{
		addAsin : {
			handler(val){},
			deep : true
		},
	}
}
</script>

<style scoped>
.asin-list-monitoring2-main-div{
	display: flex;
	flex-direction: column;
	height: 100%;
}

.search-bar-div {
	padding: 10px;
	border-bottom: 1px solid #ebeef5;
}
.table-div {
	flex: 1;
	position: relative;
}
.el-table-20230223{
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.item-asin-info-div {
	line-height: 25px;
	display: flex;
	height: auto;
	align-items: flex-start;
}
.item-asin-info-div .asin-info > span{
	margin-left: 15px;
}

.page-div {
	padding: 15px 20px;
	text-align: right;
}
.add-asin-title{
	padding: 0 10px;
	line-height: 28px;
	font-weight: bolder;
}
.add-asin-card .asin-info{
	margin-top: 5px;
}
.add-asin-card .asin-info > span{
	margin-left: 10px;
}
</style>
<style>
.el-rate-20230221 {
	font-size: 14px;
	display: inline-block;
	padding-top: 2px;
}

.el-rate-20230221 > span > i {
	margin-right: 0;
	font-size: 14px;
}

.el-rate-20230221 .el-rate__text {
	margin-left: 2px;
	font-size: 14px;
}
</style>